import { Injectable } from '@angular/core';
import { format, toZonedTime } from 'date-fns-tz';

@Injectable({
  providedIn: 'root'
})
export class FormDataService {

  //CURRENT DATE:
  getLocalDate(): string {
    const timeZone = 'America/Port_of_Spain'; // or use Intl.DateTimeFormat().resolvedOptions().timeZone
    const now = new Date();
    const localNow = toZonedTime(now, timeZone);

    const formatted = format(localNow, 'yyyy-MM-dd', { timeZone });
    return formatted;
  }

  formattedDate = this.getLocalDate();
 
  //current company ID for all table submission
  private currCompanyID = 0;

  //Now that we introduced Form saving to db on every next, 
  // formData is only used to load form once logged in
  private formData: {
    user: {
      dteCreated: string; 
      role: string; 
      strAccountStatus: string; 
      strAccountStatusDate: string;
      strJobTitle: string; 
      strContact: string; 
      strEmail: string; 
      strName: string;
      strTitle: string;
      strPassword: string; 
      signatureFile: File | null; 
    };
    company: {
      blnAffiliation: boolean;
      dteEstablished: string;
      dteRegistration: string;
      strRegistrationNum: string;
      strnumEmployees: string;
      strAffiliation: string;
      strCompanyAffiliated: string;
      strCompanyName: string;
      strCompanyWebsite: string;
      strMailingAddress: string;
      strMailingCountry: string;
      strRegisteredAddress: string;
      strRegisteredCountry: string;
      strOtherOrgType: string;
      intCompanyOrgTypeFK: any;
    };
    documents: {
      // VAT Document Fields
      hasVatDocument: string; 
      vatRegistrationNo: string;
      noVatReason: string;
      vatExpiryDate: string;
      vatFile: File | null; 
      // BIR Document Fields
      hasBirDocument: string;
      birNo: string; 
      noBirReason: string; 
      // birExpiryDate: string;
      birFile: File | null; 
      // NIB Document Fields
      hasNibDocument: string;
      nibNo: string; 
      noNibReason: string; 
      nibExpiryDate: string;
      nibFile: File | null; 
      // Incorporation Certificate Fields
      hasIncorporationCertificate: string; 
      noIncorporationReason: string; 
      incorpFile: File | null; 
      // Registration Certificate Fields
      hasRegistrationCertificate: string; 
      regFile: File | null;
      // Company Profile Fields
      hasCompanyProfile: string; 
      companyFile: File | null; 
      // General Licenses Fields
      hasGeneralLicenses: string; 
      generalLicensesExpiryDate: string; 
      licenseFile: File | null; 
      //Terms and Conditions Agreement File
      tcFile: File | null;
      //Code of Conduct & Ethics Agreement File
      conductFile: File | null;
    }
    companyBusTypes: string[];
    directors: {
      strName: string;
      strJobPosition: string;
    }[];
    authsignatories: {
      strName: string;
      strJobPosition: string;
      strEmail: string;
      strPhoneNumber: string;
    }[];
    subsidaries: {
      strName: string;
      strAddress: string;
      strAffiliation: string;
    }[];
    strPrimaryWorkSubContracted: string[];

    //CompanyContract_Details Table
    blnAllowsSubcontracts: boolean; 
    blnContractStatus: boolean;
    strContractDetails: string;

    topcustomers: {
      strPastCustomer: string;
      dteYear: any;
      strContractValue: string;
      strContactPerson: string;
      strContactNumber: any;
      strContactEmail: any;
    }[];
    hse_docs:{
      hasSafetyFile: string; 
      safetyFile: File | null;

      hasTrainingFile: string;
      trainingFile: File | null;

      hasResourcesFile: string;
      resourcesFile: File | null;

      agreedToSustainabilityChecklist: boolean;
    }
    vendorConsent?: {
      accepted: boolean;
      version: string;
      consentText?: string;
    }
  } = {
    user: {
      dteCreated: this.formattedDate,
      // intCompanyFK: null,
      role: '',
      strAccountStatus: '',
      strAccountStatusDate: this.formattedDate,
      strJobTitle: '',
      strContact: '',
      strEmail: '',
      strName: '',
      strTitle: '',
      strPassword: '',
      signatureFile: null
    },

    company: {
      blnAffiliation: false,
      dteEstablished: '',
      dteRegistration: this.formattedDate,
      strRegistrationNum: '',
      strnumEmployees: '',
      strAffiliation: '',
      strCompanyAffiliated: '',
      strCompanyName: '',
      strCompanyWebsite: '',
      strMailingAddress: '',
      strMailingCountry: '',
      strRegisteredAddress: '',
      strRegisteredCountry: '',
      strOtherOrgType: '', 
      intCompanyOrgTypeFK: 1
    },

    documents: {
      hasVatDocument: '',
      vatRegistrationNo: '',
      noVatReason: '', 
      vatExpiryDate: '', 
      vatFile: null, 
      hasBirDocument: '', 
      birNo: '', 
      noBirReason: '', 
      // birExpiryDate: '',
      birFile: null,
      hasNibDocument: '', 
      nibNo: '', 
      noNibReason: '', 
      nibExpiryDate: '',
      nibFile: null, 
      hasIncorporationCertificate: '', 
      noIncorporationReason: '', 
      incorpFile: null, 
      hasRegistrationCertificate: '', 
      regFile: null, 
      hasCompanyProfile: '', 
      companyFile: null,
      hasGeneralLicenses: '', 
      generalLicensesExpiryDate: '', 
      licenseFile: null, 
      tcFile: null,
      conductFile: null
    }, 
    companyBusTypes: [],
    directors: [{
      strName: '',
      strJobPosition: '',
    }],

    authsignatories: [{
      strName: '',
      strJobPosition: '',
      strEmail: '',
      strPhoneNumber: '',
    }],

    subsidaries: [{
      strName: '',
      strAddress: '',
      strAffiliation: ''
    }],

    strPrimaryWorkSubContracted: [],

    blnAllowsSubcontracts: false,
    blnContractStatus: true, 
    strContractDetails: '',

    topcustomers: Array(3).fill(null).map(() =>({
      strPastCustomer: '',
      dteYear: '',
      strContractValue: '',
      strContactPerson: '',
      strContactNumber: '',
      strContactEmail: ''
    })),

    hse_docs:{ 
      hasSafetyFile: '',
      safetyFile: null,

      hasTrainingFile: '',
      trainingFile: null,

      hasResourcesFile: '',
      resourcesFile: null,

      agreedToSustainabilityChecklist: false,
    }
    ,
    vendorConsent: {
      accepted: false,
      version: '',
      consentText: '',
    }
  };
  
//GET
  getFormData(): any {
    return this.formData;
  }

  getCurrCompanyID(): any{
    return this.currCompanyID;
  }

  // getCountryRegistered(): any{
  //   return this.registeredCountry;
  // }
  // getCountryMailing(): any{
  //   return this.mailingCountry;
  // }

  // getAffiliatedSubsidary(): any{
  //   return this.affiliatedSubsidary;
  // }


  getUserData(): any {
    return this.formData.user;
  }

  getCompanyData(): any {
    return this.formData.company;
  }

  getDocumentsData():any {
    return this.formData.documents;
  }

  getCompanyBusType(): string[] {
    return this.formData.companyBusTypes;
  } 

  getstrOtherOrgType(): any {
    return this.formData.company.strOtherOrgType;
  } 

  getDirectors(): any{
    return this.formData.directors;
  }

  getAuthSignatories(): any{
    return this.formData.authsignatories;
  }

  getSubsidaries(): any{
    return this.formData.subsidaries;
  }

  getPrimaryWorks(): string[] {
    return this.formData.strPrimaryWorkSubContracted;
  } 

  getTopCustomers(): any{
    return this.formData.topcustomers;
  }

  getstrContractDetails(): string{
    return this.formData.strContractDetails;
  }

  getblnContractStatus(): any{
    return this.formData.blnContractStatus;
  }

  getHSEDocs(): any {
    return this.formData.hse_docs;
  }

  getDoesSubcontract(): any{
    return this.formData.blnAllowsSubcontracts;
  }

//UPDATE
  setCurrCompanyID(companyId: any){
    this.currCompanyID = companyId;
  }

  setintCompanyOrgTypeFK(intCompanyOrgTypeFK: any){
    this.formData.company.intCompanyOrgTypeFK = intCompanyOrgTypeFK;
  }

  // setCountryRegistered(country: string){
  //   this.registeredCountry = country;
  // }
  // setCountryMailing(country: string){
  //   this.mailingCountry = country;
  // }
  // setAffiliatedSubsidary(subsidary: string){
  //   this.affiliatedSubsidary = subsidary;
  // }

  updateFormData(updatedData: Partial<any>){
    this.formData = { ...this.formData, ...updatedData};
  }

  updateUserData(updatedUserData: Partial<any>) {
    this.formData.user = { ...this.formData.user, ...updatedUserData };
  }

  updateCompanyData(updatedCompanyData: Partial<any>) {
    this.formData.company = { ...this.formData.company, ...updatedCompanyData };
  }

  updateDocumentsData(updatedDocData: Partial<any>) {
    this.formData.documents = { ...this.formData.documents, ...updatedDocData };
  }

  updateCompanyBusType(updatedBusTypes: string[]) {
    this.formData.companyBusTypes = [...updatedBusTypes]; 
  } 
  
  updatestrOtherOrgType(updatedOrgType: string) {
    this.formData.company.strOtherOrgType = updatedOrgType;
  }
  
  updateDirectors(updatedDirectors: Partial<{ strName: string; strJobPosition: string }>[]){
    this.formData.directors = updatedDirectors.map(director => ({
      strName: director.strName ?? '',
      strJobPosition: director.strJobPosition ?? ''
    }));;
  }

  updateAuthSignatories(updatedAuths: Partial<{ strName: string; strJobPosition: string; strEmail: string; strPhoneNumber: string }>[]){
    this.formData.authsignatories = updatedAuths.map(auth => ({
      strName: auth.strName ?? '',
      strJobPosition: auth.strJobPosition ?? '',
      strEmail: auth.strEmail ?? '',
      strPhoneNumber: auth.strPhoneNumber ?? ''
    }));;
  }

  updateSubsidaries(updatedSubsidaries: Partial<{ strName: string; strAddress: string; strAffiliation: string}>[]){
    this.formData.subsidaries = updatedSubsidaries.map(subs => ({
      strName: subs.strName ?? '',
      strAddress: subs.strAddress ?? '',
      strAffiliation: subs.strAffiliation ?? '',
    }));;
  }

  updatePrimaryWork(updatedWorks: string[]) {
    this.formData.strPrimaryWorkSubContracted = [...updatedWorks]; 
  }

  updateblnContractStatus(update: any){
    this.formData.blnContractStatus = update;
  }

  updatestrContractDetails(update: string){
    this.formData.strContractDetails = update;
  }

  updateTopCustomers(update: Partial<{ 
    strPastCustomer: string;
    dteYear: any;
    strContractValue: any;
    strContactPerson: string;
    strContactNumber: any;
    strContactEmail: any;
    }>[]) {
    this.formData.topcustomers = update.map(cust => ({
        strPastCustomer: cust.strPastCustomer || '',
        dteYear: cust.dteYear === '' ? null : cust.dteYear,
        strContractValue: cust.strContractValue || '',
        strContactPerson: cust.strContactPerson || '',
        strContactNumber: cust.strContactNumber || '',
        strContactEmail: cust.strContactEmail || '',
    }));
  }

  updateHSEDocs(updatedDocs: Partial<any>) {
    this.formData.hse_docs = { ...this.formData.hse_docs, ...updatedDocs };
  }


  updateDoesSubcontract(update: boolean){
   this.formData.blnAllowsSubcontracts = update;
  }

  resetFormData() {
    this.formData = {
      user: {
        dteCreated: this.formattedDate,
        // intCompanyFK: null,
        role: '',
        strAccountStatus: '',
        strAccountStatusDate: this.formattedDate,
        strJobTitle: '',
        strContact: '',
        strEmail: '',
        strName: '',
        strTitle: '',
        strPassword: '',
        signatureFile: null
      },
  
      company: {
        blnAffiliation: false,
        dteEstablished: '',
        dteRegistration: this.formattedDate,
        strRegistrationNum: '',
        strnumEmployees: '',
        strAffiliation: '',
        strCompanyAffiliated: '',
        strCompanyName: '',
        strCompanyWebsite: '',
        strMailingAddress: '',
        strMailingCountry: '',
        strRegisteredAddress: '',
        strRegisteredCountry: '',
        strOtherOrgType: '', 
        intCompanyOrgTypeFK: 1
      },
  
      documents: {
        // intCompanyFK: 0,
        hasVatDocument: '',
        vatRegistrationNo: '',
        noVatReason: '', 
        vatExpiryDate: '', 
        vatFile: null, 
        hasBirDocument: '', 
        birNo: '', 
        noBirReason: '', 
        // birExpiryDate: '',
        birFile: null,
        hasNibDocument: '', 
        nibNo: '', 
        noNibReason: '', 
        nibExpiryDate: '',
        nibFile: null, 
        hasIncorporationCertificate: '', 
        noIncorporationReason: '', 
        incorpFile: null, 
        hasRegistrationCertificate: '', 
        regFile: null, 
        hasCompanyProfile: '', 
        companyFile: null,
        hasGeneralLicenses: '', 
        generalLicensesExpiryDate: '', 
        licenseFile: null, 
        tcFile: null,
        conductFile: null
      }, 
      companyBusTypes: [],
      directors: [{
        strName: '',
        strJobPosition: '',
      }],
  
      authsignatories: [{
        strName: '',
        strJobPosition: '',
        strEmail: '',
        strPhoneNumber: '',
      }],
  
      subsidaries: [{
        strName: '',
        strAddress: '',
        strAffiliation: ''
      }],
  
      strPrimaryWorkSubContracted: [],
  
      blnAllowsSubcontracts: false,
      blnContractStatus: true, 
      strContractDetails: '',
  
      topcustomers: Array(3).fill(null).map(() =>({
        strPastCustomer: '',
        dteYear: '',
        strContractValue: '',
        strContactPerson: '',
        strContactNumber: '',
        strContactEmail: ''
      })),
  
      hse_docs:{ 
        hasSafetyFile: '',
        safetyFile: null,
  
        hasTrainingFile: '',
        trainingFile: null,
  
        hasResourcesFile: '',
        resourcesFile: null,
  
        agreedToSustainabilityChecklist: false,
      }
      ,
      vendorConsent: {
        accepted: false,
        version: '',
        consentText: '',
      }
    };
  }
}
